import FaqService from '../services/faq.service';

export const faq = {
  namespaced: true,
  actions: {
    get({ commit }) {
      return FaqService.get();
      // return BannerHomeService.get().then(
      //   resp => {
      //     return Promise.resolve(resp);
      //   },
      //   error => {
      //     return Promise.reject(error);
      //   }
      // );
    }
  },
  mutations: {
    }
};
